module.exports = __webpack_public_path__ + "img/mulu-logo_400.3228a454.png";